module.exports = __webpack_public_path__ + "media/images/powerpoint/media/country-c5927c26d2748dacf40a36fd5d7dd7a8.png";